import { useSearchParams } from 'react-router';
import { useCallback } from 'react';

type TSearchValues = {
  searchParams: URLSearchParams;
  setSearchParams: (param: string, value: string) => void;
  removeParam: (param: string) => void;
  clearParams: () => void;
};

export const useSetSearchParam = (): TSearchValues => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setParam = useCallback(
    (key: string, value: string) => {
      setSearchParams(
        () => {
          const next = new URLSearchParams(window.location.search);
          next.set(key, value);
          return next;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  const removeParam = useCallback(
    (key: string) => {
      setSearchParams(
        () => {
          const next = new URLSearchParams(window.location.search);
          next.delete(key);
          return next;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  const clearParams = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  return { searchParams, setSearchParams: setParam, clearParams, removeParam };
};
